const archive = document.querySelector('body.archive.category');

if(archive) {
  let selectedYear = new URLSearchParams(document.location.search).get('y') || '';

  if(archive.querySelector('.filter-group.year .select-options li a.selected')) {
    archive.querySelector('.filter-group.year .active-input span').innerHTML = archive.querySelector('.filter-group.year .select-options li a.selected').getAttribute('data-name');
  }

  const yearSelect = archive.querySelector('.filter-group.year .active-input');
  yearSelect.addEventListener('click', function(e) {
    e.preventDefault();
    if(!this.classList.contains('open')) {
      $(this.closest('.select-input').querySelector('.select-options')).slideDown(500);
      this.classList.add('open');
      this.querySelector('button').setAttribute('aria-expanded', 'true');
      if(window.innerWidth >= 768) {
        document.querySelector('body').classList.add('no-scroll');
        $('html, body').animate({
          scrollTop: $(this).offset().top - 100
        }, 300);
      }
    }
    else {
      $(this.closest('.select-input').querySelector('.select-options')).slideUp(500);
      this.classList.remove('open');
      this.querySelector('button').setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('no-scroll');
    }
  });

  const yearOptions = archive.querySelectorAll('.filter-group.year .select-options li a');
  yearOptions.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      let path = window.location.pathname.replace(/\/page\/\d+/, `/page/1`);
      if(this.value != '') {
        selectedYear = this.getAttribute('data-value');
        window.location.href = path + '?y=' + selectedYear;
      }
      else {
        window.location.href = path;
      }
    });
  });

  window.addEventListener('click', function(e) {
    if (!e.target.closest('.active-input') && archive.querySelector('.active-input').classList.contains('open')) {
      $(archive.querySelector('.active-input.open').closest('.select-input').querySelector('.select-options')).slideUp(500);
      archive.querySelector('.active-input.open').classList.remove('open');
      archive.querySelector('.active-input button').setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('no-scroll');
    }
  });
}